import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {Provider} from 'react-redux';
import { store } from './storage/initial';
import axios from 'axios';
import {installPasswordGate} from './api/PasswordGate';

// Add default header to bypass ngrok interstitial page
axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'true';

installPasswordGate();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App/>
        </BrowserRouter>
    </Provider>
);
